import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BusAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bus_alert"}/>
}
